import React, {useState} from 'react';
import {useLimitesAprobadosCLFB} from "../../sistema/sistemas/clfb/hooks/useLimitesAprobadosCLFB";
import LimiteCLFB from "./LimiteCLFB";
import {Alert, Grid} from "@mui/material";
import {QueryStatus} from "../../../types";

import {OperacionCLFBLimitesAprobadosFields} from "../../sistema/sistemas/clfb/types/fields";
import {FiltrosBusqueda, FormFiltros, FormFiltrosFields, schemaFiltrosBusqueda} from '../FiltrosBusqueda';
import {SistemaTipo} from "../../../types/enum/enum";

interface LimitesCLFBProps {
}

function LimitesCLFB({}: LimitesCLFBProps) {
    const [apiFiltros, setApiFiltros] = useState<FormFiltros>(schemaFiltrosBusqueda.parse({}));

    const {data, status} = useLimitesAprobadosCLFB(apiFiltros);

    const handleFilterChange = (nuevosFiltros: FormFiltros) => {
        setApiFiltros(nuevosFiltros);
    };

    return (
        <Grid container gap={10}>
            <Grid item xs={12} sx={{mb: -5}}>
                <FiltrosBusqueda
                    formFields={[FormFiltrosFields.Pais]}
                    onFilterChange={handleFilterChange}
                    debounceFields={[]}
                    mensajeTipo={SistemaTipo.CLFB}
                />
            </Grid>
            {
                data &&
                data.map(d => {
                    return (
                        <Grid item xs={12} key={d[OperacionCLFBLimitesAprobadosFields.CountryCode]}>
                            <LimiteCLFB data={d}/>
                        </Grid>
                    )
                })
            }

            {
                (!data?.length && status === QueryStatus.Success) &&
                <Alert severity="warning">No se encontraron datos.</Alert>
            }
        </Grid>
    );
}

export default LimitesCLFB;
